import doctor from "../../../src/assets/sounds/lesson3/doctor.mp3"
import teacher from "../../../src/assets/sounds/lesson3/teacher.mp3"
import nurse from "../../../src/assets/sounds/lesson3/nurse.mp3"
import engineer from "../../../src/assets/sounds/lesson3/engineer.mp3"
import director from "../../../src/assets/sounds/lesson3/director.mp3"
import your_job from "../../../src/assets/sounds/lesson3/your-job.mp3"
import do_work from "../../../src/assets/sounds/lesson3/do_work.mp3"
import student from "../../../src/assets/sounds/lesson3/student.mp3"
import pupil from "../../../src/assets/sounds/lesson3/pupil.mp3"
import staff from "../../../src/assets/sounds/lesson3/staff.mp3"
import accountant from "../../../src/assets/sounds/lesson3/accountant.mp3"
import manager from "../../../src/assets/sounds/lesson3/manager.mp3"
import resources from "../../../src/assets/sounds/lesson3/resources.mp3"
import company from "../../../src/assets/sounds/lesson3/company.mp3"
import which from "../../../src/assets/sounds/lesson3/which.mp3"
import police from "../../../src/assets/sounds/lesson3/police.mp3"
import businessman from "../../../src/assets/sounds/lesson3/businessman.mp3"
import businesswoman from "../../../src/assets/sounds/lesson3/businesswoman.mp3"

import doctor_pic from "../../../src/assets/lesson3/doctor.png"
import teacher_pic from "../../../src/assets/lesson3/teacher.png"
import nurse_pic from "../../../src/assets/lesson3/nurse.png"
import engineer_pic from "../../../src/assets/lesson3/engineer.png"
import director_pic from "../../../src/assets/lesson3/director.png"
import your_job_pic from "../../../src/assets/lesson3/what_ur_job.png"
import do_work_pic from "../../../src/assets/lesson3/do.png"
import student_pic from "../../../src/assets/lesson3/student.png"
import pupil_pic from "../../../src/assets/lesson3/pupil.png"
import staff_pic from "../../../src/assets/lesson3/staff.png"
import accountant_pic from "../../../src/assets/lesson3/accountant.png"
import manager_pic from "../../../src/assets/lesson3/manager.png"
import resources_pic from "../../../src/assets/lesson3/hr.png"
import company_pic from "../../../src/assets/lesson3/company.png"
import which_pic from "../../../src/assets/lesson3/which.png"
import police_pic from "../../../src/assets/lesson3/police.png"
import businessman_pic from "../../../src/assets/lesson3/businessman.png"
import businesswoman_pic from "../../../src/assets/lesson3/businesswoman.png"

export const unit_3 = [
    {id:0,
    english:'Doctor',
    vietnamese:'Bác sĩ',
    audio:doctor,
    example:'Tôi là bác sĩ, thế còn em?',
    picture:doctor_pic
    },
    {id:1,
    english:'Teacher',
    vietnamese:'Giáo viên',
    audio:teacher,
    example:'Cô giáo nói tiếng việt',
    picture:teacher_pic
    },
    {id:2,
    english:'Nurse',
    vietnamese:'Y tá',
    audio:nurse,
    example:'Cô y tá rất tốt bụng',
    picture:nurse_pic
    },
    {id:3,
    english:'Engineer',
    vietnamese:'Kỹ sư',
    audio:engineer,
    example:'Kỹ sư xây nhà',
    picture:engineer_pic
    },
    {id:4,
    english:'Director',
    vietnamese:'Giám đốc',
    audio:director,
    example:'Giám đốc rất nghiêm khắc',
    picture:director_pic
    },        
    {id:5,
    english:'What is your job?',
    vietnamese:'Làm nghề gì?',
    audio:your_job,
    example:'Chào chị, xin lỗi chị làm nghề gì ạ?',
    picture: your_job_pic
    },
    {id:6,
    english:'Do/work',
    vietnamese:'Làm',
    audio:do_work,
    example:'Chị đang làm cho công ty nào ạ?',
    picture:do_work_pic
    },
    {id:7,
    english:'Student',
    vietnamese:'Sinh viên',
    audio:student,
    example:'Học sinh đã hoàn thành kỳ nghỉ hè của họ',
    picture:student_pic
    },
    {id:8,
    english:'Pupil',
    vietnamese:'Học sinh',
    audio:pupil,
    example:'Học sinh đeo khẩu trang',
    picture:pupil_pic
    },
    {id:9,
    english:'Staff',
    vietnamese:'Nhân viên',
    audio:staff,
    example:'Tất cả nhân viên gặp nhau vào buổi tối',
    picture:staff_pic
    },
    {id:10,
    english:'Accountant',
    vietnamese:'Kế toán viên',
    audio:accountant,
    example:'Kế toán trả lương',
    picture:accountant_pic
    },
    {id:11,
    english:'Manager',
    vietnamese:'Quản lý',
    audio:manager,
    example:'Quản lý mặc đồng phục đặc biệt',
    picture:manager_pic
    },
    {id:12,
    english:'Human resources',
    vietnamese:'Nhân sự',
    audio:resources,
    example:'Phòng nhân sự đang tìm kiếm lập trình viên',
    picture:resources_pic
    },
    {id:13,
    english:'Company',
    vietnamese:'Công ty',
    audio:company,
    example:'Các công ty CNTT đầy hứa hẹn cho nền kinh tế',
    picture:company_pic
    },
    {id:14,
    english:'Which',
    vietnamese:'Nào/ cái nào',
    audio:which,
    example:'Cái nào là của bạn?',
    picture:which_pic
    },
    {id:15,
    english:'Police',
    vietnamese:'Công an',
    audio:police,
    example:'Công an bắt tội phạm nguy hiểm',
    picture:police_pic
    },
    {id:16,
    english:'Businessman',
    vietnamese:'Nam doanh nhân',
    audio:businessman,
    example:'Doanh nhân có nhiều cuộc họp kinh doanh',
    picture:businessman_pic
    },
    {id:17,
    english:'Businesswoman',
    vietnamese:'Nữ doanh nhân',
    audio:businesswoman,
    example:'Doanh nhân có nhiều cuộc họp kinh doanh',
    picture:businesswoman_pic
    },
]